import React, { useState } from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import AdditionalDocumentUploadForm from "features/AdditionalDocuments/AdditionalDocumentUploadForm";

const AddAdditionalDocumentModal = ({
  as: As = Button,
  submitAction,
  onSubmitted,
  triggerText,
  headerText,
  dealerId,
  dealerOfficeId,
  ...props
}) => {
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <ModalBuilder
      withForm
      submitAction={submitAction}
      submitParams={{ dealerId, dealerOfficeId, uploadDoc }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <As {...props} primary onClick={showModal}>
          {triggerText}
        </As>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Add {...modalProps} header={headerText}>
          <AdditionalDocumentUploadForm
            {...formProps}
            onChangeUpload={onChangeUpload}
          />
        </Modal.Add>
      )}
    />
  );
};

export default AddAdditionalDocumentModal;
